import { Model } from "@vuex-orm/core"
import StudentCourse from "@/models/StudentCourse"

export default class Presence extends Model {
  static get entity() {
    return "presences"
  }

  static fields() {
    return {
      id: this.attr(null),
      student_course_id: this.attr(null),
      statut: this.attr(""),
      comment: this.attr(""),
      date: this.attr(""),
      created_at: this.attr(""),
      updated_at: this.attr(""),
      student_course: this.belongsTo(StudentCourse, "student_course_id"),
    }
  }

  get evamCode() {
    const status = this.statut
    let evamCode = ""
    // Absent (sans justification)
    if (status === "absence non excusée") {
      evamCode = "A"
    }
    // Excuse autre (enfant malade, absence administrative, etc.)
    else if (status === "absence excusée") {
      evamCode = "EA"
    }
    // Excuse médicale
    else if (status === "maladie certificat médical") {
      evamCode = "EM"
    }
    // Stage
    else if (status === "en stage") {
      evamCode = "S"
    }
    // Note: Retard EVAM code now handled in Checkin model

    return evamCode ? " (" + evamCode + ")" : ""
  }

  static statuts(withAll = false, isAdmin = false) {
    // Note: retards/departs moved to checkins, arrêt moved to StudentCourse.stopped_at
    let statuts = [
      { value: "présent", text: "présent" },
      { value: "absence excusée", text: "absence excusée" },
      { value: "absence non excusée", text: "absence non excusée" },
    ]

    if (isAdmin) {
      const adminStatuts = [
        { value: "maladie certificat médical", text: "maladie certificat médical" },
        { value: "en congé", text: "en congé" },
        { value: "en stage", text: "en stage" },
      ]
      statuts.push(...adminStatuts)
    }
    if (withAll) {
      statuts.unshift({ value: "tout", text: "tout" })
      statuts = statuts.filter((s) => s.value !== "présent")
    }

    return statuts
  }

  static async getByStudentCourseId(student_course_id) {
    return await this.api().get(`/student_course/presences/${student_course_id}`, {
      dataKey: "data",
    })
  }

  static async postMultiple(presence, dateList) {
    presence.date_list = dateList
    return this.api().post(`/presences/`, presence, {
      dataKey: "data",
    })
  }

  static async put(presence) {
    return this.api().put(`/presences/`, presence, {
      dataKey: "data",
    })
  }

  static async deleteOne(id) {
    return await this.api().delete("/presences/" + id, {
      delete: id,
    })
  }

  static async getPresencesBetweenDates(start, end, status, activeCoursesOnly = false) {
    return await this.api().get(
      `/presences/between_dates?start=${start}&end=${end}&statut=${status}&active_courses=${activeCoursesOnly}`,
      {
        dataKey: "data",
      }
    )
  }
}
